export const stringHtmlFromString = (originalString) => originalString.replace(/(<([^>]+)>)/gi, "");
